'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &:hover {\n    .ant-checkbox-inner {\n      border-color: ", ";\n    }\n  }\n\n  .ant-checkbox-checked {\n    .ant-checkbox-inner {\n      border-color: ", "!important;\n      background-color: ", "!important;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _checkbox = require('antd/lib/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var ThemedCheckbox = (0, _styledComponents2.default)(_checkbox2.default)(_templateObject(), function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
});

var checkBox = function checkBox(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(ThemedCheckbox, props, children);
};

exports.default = checkBox;